"use strict";
/**
 * Abstract Repository Interface for Policy Aggregate Persistence.
 * 0% dependency on infrastructure/database.
 */
Object.defineProperty(exports, "__esModule", { value: true });
